export default "__VITE_ASSET__0GwY1_hY__"